module.exports = __webpack_public_path__ + "img/ico_option_plus_on.06596b56.svg";